<template>
    <!-- Existing work -->
    <div class="existing-work" v-if="doShow">
        <div class="grid-x existing-work-header align-items">
            <div>
                <icon class="location-svg medium-svg fill-medium-gray" name="location" />
            </div>
            <div class="cell auto">
                <!-- Enquiries -->
                <span v-if="existingEnquiries.length > 0">{{existingEnquiries.length}}
                    <span v-if="existingEnquiries.length > 1"> andre</span>
                    <span v-else> anden</span>
                    henvendelse<span v-if="existingEnquiries.length > 1">r</span>
                </span>
                <span v-if="existingEnquiries.length > 0 && existingTasks.length > 0">og</span>

                <!-- Tasks -->
                <span v-if="existingTasks.length > 0">{{existingTasks.length}}
                    <span v-if="existingTasks.length > 1"> andre</span>
                    <span v-else> anden</span>
                    opgave<span v-if="existingTasks.length > 1">r</span></span>
                <span>på adressen</span>
            </div>
        </div>

        <!-- Enquiries -->
        <div v-for="enquiry in existingEnquiries" :key="enquiry.requestId" class="grid-x existing-enquiries align-items">
            <div>
                <icon class="enquiry-svg medium-svg" :class="{'fill-dark-gray': !permissions.requests.enabled, 'fill-primary': permissions.requests.enabled}" name="enquiry" />
            </div>
            <div class="cell auto">
                <a @click="goToWork('enquiryid', enquiry.requestId)" :class="{disabled: !permissions.requests.enabled}">
                    {{ enquiry.occurrenceDateTime | formatDateShortElapsed }}
                    <span v-if="enquiry.problemType"> - {{ enquiry.problemType }}</span>
                    <span v-else> - ingen problemtype</span>
                    <span v-if="enquiry.requestStatus"> ({{ enquiry.requestStatus }})</span>
                </a>
            </div>
        </div>

        <!-- Tasks -->
        <div v-for="task in existingTasks" :key="task.requestId" class="grid-x existing-tasks align-items">
            <div>
                <icon class="task-svg medium-svg" :class="{'fill-dark-gray': !permissions.tasks.enabled, 'fill-primary': permissions.tasks.enabled}" name="task" />
            </div>
            <div class="cell auto">
                <a @click="goToWork('taskid', task.taskId)" :class="{disabled: !permissions.tasks.enabled}">
                    {{ task.taskName }}
                    <span v-if="task.activityCount > 0"> - {{ task.activityCount }} aktivitet<span v-if="task.activityCount > 1">er</span>
                    <span v-if="task.status"> ({{ task.status }})</span>
                    </span>
                    <span v-else> - ingen aktiviteter</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'ExistingWork',
        props: {
            existingWork: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                doShow: false
            }
        },
        created () {
            if (this.existingWork.enquiries) {
                this.doShow = this.existingWork.enquiries.length > 0
            }
            if (this.existingWork.tasks) {
                this.doShow = this.existingWork.tasks.length > 0
            }
        },
        computed: {
            ...mapGetters({
                permissions: 'permissions'
            }),
            checkRouter () {
                if (this.$route.name === 'requisition') {
                    return true
                } else {
                    return false
                }
            },
            existingEnquiries () {
                return this.existingWork.enquiries ? this.existingWork.enquiries : []
            },
            existingTasks () {
                return this.existingWork.tasks ? this.existingWork.tasks : []
            }
        },
        methods: {
            ...mapActions({
            }),
            goToWork (workType, workId) {
                let workLink = this.$router.resolve({name: workType, params: {id: workId}})
                window.open(workLink.href, '_blank')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/shared/list/list-existing-work.vue